// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"splash-module--wrapper--3JW6G"};